
const urls = {
    rootAPIURL: 'https://bfatechnologies.tech/tz_schools_is/school/',
    //rootAPIURL: 'http://localhost:8000/school/',
    //rootAPIURL: 'http://',
    rootLocalAPIURL:  'http://192.168.100.220:8000',
    rootLocalAPIURLB: 'http://localhost:8000',
    imageURL: 'https://bfatechnologies.tech/images/tanzania-cnlg-logo-01.jpg',
    //imageURL: './../assets/images/tanzania-cnlg-logo-01.jpg'
    imageXURL: 'https://bfatechnologies.tech/bariadi_tax_collection/MC202408090401undefined17.png'
    ///https://bfatechnologies.tech/tz_schools_is/school/
  };
  
  export default urls;
  